// Function to fetch airport list 
import axios from 'axios';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const token = localStorage.getItem('token');
console.log(token);

export async function fetchAirlineList(AirlineQuery) {
    console.log("AirlineList Request", AirlineQuery)
    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/Admin/GetAirlineList`,
            AirlineQuery,
            {
                headers: {

                    'Authorization': `Bearer ${token}`,
                    'Content-Type': "application/json"
                }
            }
        );
        console.log(response)   
        return response.data;
    } catch (error) {
        console.error('Failed to fetch airport list:', error);
        throw error;
    }
}

// Add Airport 
export async function AddUpdateAirline(payload) {
    console.log("Add Airline Request", payload)
    
    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/Admin/AddUpdateAirline`,
            payload,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            }
        );
        // Added page reload after successful add/update
        debugger;
        console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Failed to fetch airport list:', error);
        throw error;
    }
}

export async function deleteAirline(airlineId) {
    console.log("Delete Airline Request", airlineId);
    // console.log(token)

    // const payload = { Id: airportId };
    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/Admin/DeleteAirlineById/${airlineId}`,
            {},
            {
                headers: {

                    'Authorization':`Bearer ${token}`,
                    'Content-Type': "application/json",
                }
            }
        );
        console.log("Airline Add Update Responce",response.data)
        return response.data;
    } catch (error) {
        console.error('Failed to delete airport:', error);
        throw error;
    }
}



